import { EnrichedBacklogMetricsByWorkstream } from '@/pages/OperationsInsights/types/BacklogMetricsResponseEnriched';
import { roundToOneDecimal } from '@/pages/OperationsInsights/utils/roundNumber';
import SLAHealthPercentageCellRenderer from '@/pages/agGridUtils/SLAHealthPercentageCellRenderer.vue';

/**
 * Transform Grid Data for - Backlog Health By Workstream
 *
 * @param metrics
 */
export const tfGdBLHealthByWorkstream = (metrics: EnrichedBacklogMetricsByWorkstream[]) => {
    const gridMap = new Map<number, object>();
    for (const wsMetrics of metrics) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const row: any = {
            name: wsMetrics.name,
            openWithinSLA: wsMetrics.openWithinSLAEoP,
            openAtRisk: wsMetrics.openAtRiskEoP,
            openBreached: wsMetrics.openBreachedEoP
        };

        let slaHealthPercentOfFirstBucket = 0;
        let slaHealthPercentOfLastBucket = 0;
        if (wsMetrics.openCountBoP && wsMetrics.openWithinSLABoP) {
            slaHealthPercentOfFirstBucket = roundToOneDecimal( ((wsMetrics.openWithinSLABoP ) / wsMetrics.openCountBoP ) * 100);
        }
        if (wsMetrics.openCountEoP && wsMetrics.openWithinSLAEoP) {
            slaHealthPercentOfLastBucket = roundToOneDecimal( ((wsMetrics.openWithinSLAEoP) / wsMetrics.openCountEoP ) * 100);
        }
        row['slaHealthPercent'] = slaHealthPercentOfLastBucket;
        // slaHealthPercentChanges is used to render up and down changes in `SLAHealthPercentageCellRenderer`
        row['slaHealthPercentChanges'] = roundToOneDecimal(slaHealthPercentOfLastBucket - slaHealthPercentOfFirstBucket);

        gridMap.set(wsMetrics.workstreamDefinitionId, row);
    }
    return Array.from(gridMap.values());
};

/**
 * Colum Definition for Backlog Health By Workstream
 */
export const getBLHealthByWorkstreamColumnDefs = () => {
    return [
        {
            field: 'name', headerName: 'Workstream', flex: 2, filter: true
        },
        {
            field: 'openWithinSLA', headerName: 'Open in SLA', flex: 1, filter: true
        },
        {
            field: 'openAtRisk', headerName: 'Open At Risk', flex: 1, filter: true
        },
        {
            field: 'openBreached', headerName: 'Open Breached', flex: 1, filter: true
        },
        {
            field: 'slaHealthPercent', headerName: 'SLA Health', flex: 1, cellRenderer: SLAHealthPercentageCellRenderer, filter: true
        }
    ];
};